/*
 * @Author: bz2021 bz2021@mail.sdu.edu.cn
 * @Date: 2025-07-02 12:30:49
 * @LastEditors: bz2021 bz2021@mail.sdu.edu.cn
 * @LastEditTime: 2025-07-06 14:50:28
 * @FilePath: \a_span\frontend\management-app\src\pages\UserList.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from 'react';
import { Table, Input, Space, Button, message, Modal, Form, Select, Checkbox } from 'antd';
import { getUser, createUser, updateUser, getUserlist } from '../api/auth';

const { Option } = Select;
const { FormItem } = Form;

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const [sorting, setSorting] = useState({
    sortBy: '',
    sortOrder: '',
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalType, setModalType] = useState('add'); // 'add' or 'edit'
  const [currentUser, setCurrentUser] = useState(null);
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  // 获取用户列表数据
  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await getUserlist({
        page: pagination.current,
        page_size: pagination.pageSize,
        username: searchText,
        sort_by: sorting.sortBy,
        sort_order: sorting.sortOrder,
      });
      setUsers(response.data.users);
      setTotal(response.data.total);
    } catch (error) {
      messageApi.error('获取用户列表失败: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  // 获取单个用户详情
  const fetchUserDetail = async (userId) => {
    try {
      const response = await getUser(userId);
      return response.data;
    } catch (error) {
      messageApi.error('获取用户详情失败: ' + (error.response?.data?.message || error.message));
      return null;
    }
  };

  // 打开添加用户模态框
  const handleAdd = () => {
    setModalType('add');
    setCurrentUser(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  // 打开编辑用户模态框
  const handleEdit = async (userId) => {
    setLoading(true);
    const user = await fetchUserDetail(userId);
    setLoading(false);
    if (user) {
      setModalType('edit');
      setCurrentUser(user);
      form.setFieldsValue({
        username: user.username,
        email: user.email,
        admin: user.admin,
        super_admin: user.super_admin,
      });
      setIsModalVisible(true);
    }
  };

  // 关闭模态框
  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  // 提交表单（添加/编辑用户）
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      if (modalType === 'add') {
        // 创建新用户
        await createUser({
          username: values.username,
          password: values.password,
          email: values.email,
          admin: values.admin,
          super_admin: values.super_admin,
        });
        messageApi.success('用户创建成功');
      } else {
        // 更新用户
        await updateUser(currentUser.user_id, {
          username: values.username,
          email: values.email,
          admin: values.admin,
          super_admin: values.super_admin,
          password: values.password || undefined,
        });
        messageApi.success('用户更新成功');
      }

      setIsModalVisible(false);
      fetchUsers(); // 重新加载用户列表
    } catch (error) {
      if (error.name !== 'ValidationError') {
        messageApi.error('操作失败: ' + (error.response?.data?.message || error.message));
      }
    } finally {
      setLoading(false);
    }
  };

  // 初始加载和参数变化时重新获取数据
  useEffect(() => {
    fetchUsers();
  }, [pagination.current, pagination.pageSize, sorting.sortBy, sorting.sortOrder]);

  // 搜索处理
  const handleSearch = () => {
    setPagination({ ...pagination, current: 1 });
    fetchUsers();
  };

  // 排序和分页变化处理
  const handleTableChange = (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorting({
      sortBy: sorter.field || '',
      sortOrder: sorter.order ? (sorter.order === 'ascend' ? 'asc' : 'desc') : '',
    });
  };

  const columns = [
    { title: '用户ID', dataIndex: 'user_id', key: 'user_id', sorter: true },
    { title: '用户名', dataIndex: 'username', key: 'username', sorter: true },
    { title: '邮箱', dataIndex: 'email', key: 'email' },
    { title: '超级管理员', dataIndex: 'super_admin', key: 'super_admin', render: (superAdmin) => superAdmin ? '✔' : '❌️' },
    { title: '管理员', dataIndex: 'admin', key: 'admin', render: (admin) => admin ? '✔' : '❌️' },
    { 
      title: '创建时间', 
      dataIndex: 'created_at', 
      key: 'created_at', 
      sorter: true,
      render: (createdAt) => {
        if (!createdAt) return '';
        const date = new Date(createdAt);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}.${month}.${day} ${hours}:${minutes}`;
      }
    },
    { 
      title: '上次登录', 
      dataIndex: 'last_login', 
      key: 'last_login', 
      sorter: false,
      render: (lastLogin) => {
        if (lastLogin == 0 || lastLogin === '0001-01-01T00:00:00Z') return '从未登录过';
        const diff = Date.now() - new Date(lastLogin).getTime();
        const minutes = Math.floor(diff / (1000 * 60));
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const months = Math.floor(days / 30);

        if (months > 0) return `${months}个月前`;
        if (days > 0) return `${days}天前`;
        if (hours > 0) return `${hours}小时前`;
        return `${minutes}分钟前`;
      }
    },
    {
      title: '操作', 
      key: 'action', 
      render: (_, record) => 
      <Button type='primary'
      onClick={() => handleEdit(record.user_id)}>编辑</Button> 
    },
  ];

  return (
    <div className="user-list-container">
      {contextHolder}
      <Space style={{ marginBottom: 16 }}>
        <Button type="primary" onClick={handleAdd}>添加用户</Button>
        <Input
          placeholder="输入用户名搜索"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onPressEnter={handleSearch}
          style={{ width: 200 }}
        />
        <Button type="primary" onClick={handleSearch}>搜索</Button>
      </Space>
      <Table
        columns={columns}
        dataSource={users.map(user => ({ ...user, key: user.user_id }))}
        loading={loading}
        pagination={{ ...pagination, total, showSizeChanger: true, showTotal: (total) => `共 ${total} 条记录` }}
        onChange={handleTableChange}
      />
        <Modal
          title={modalType === 'add' ? '添加用户' : '编辑用户'}
          open={isModalVisible}
          onCancel={handleCancel}
          footer={null}
        >
          <Form
            form={form}
            layout="vertical"
            initialValues={currentUser}
          >
            <Form.Item
              name="username"
              label="用户名"
              rules={[{ required: true, message: '请输入用户名' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="email"
              label="邮箱"
              rules={[
                { required: true, message: '请输入邮箱' },
                { type: 'email', message: '请输入有效的邮箱地址' }
              ]}
            >
              <Input />
            </Form.Item>
            {modalType === 'add' && (
              <Form.Item
                name="password"
                label="密码"
                rules={[{ required: true, message: '请输入密码' }]}
              >
                <Input.Password />
              </Form.Item>
            )}
            {modalType === 'edit' && (
              <Form.Item
                name="password"
                label="密码"
              >
                <Input.Password placeholder="输入新密码（不输入则不修改）" />
              </Form.Item>
            )}
            <Form.Item
              name="admin"
              label="管理员权限"
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
            <Form.Item
              name="super_admin"
              label="超级管理员权限"
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
            <Form.Item>
              <Space>
                <Button onClick={handleCancel}>取消</Button>
                <Button type="primary" loading={loading} onClick={handleSubmit}>
                  {modalType === 'add' ? '创建' : '更新'}
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
    </div>
  );
};

export default UserList;